import { Store } from "utils";
import lunr from "lunr";

import lunrStemmerSupport from "lunr-languages/lunr.stemmer.support";
import lunrMulti from "lunr-languages/lunr.multi";
import lunrRu from "lunr-languages/lunr.ru";
lunrStemmerSupport(lunr);
lunrMulti(lunr);
lunrRu(lunr);

class JobStore extends Store {
  getInitialState() {
    return {
      jobs: null,
      query: "",
      loading: false,
      standId: "",
      background: null,
      details: null,
      index: null,
      activeJobs: null,
      map: null,
      filters: {
        categories: [],
        positions: [],
        locations: [],
        companies: [],
      },
      initialFilters: {
        categories: [],
        positions: [],
        locations: [],
        companies: [],
      },
      activeFilters: {
        categories: [],
        positions: [],
        locations: [],
        companies: [],
      },
      indexes: {
        categories: [],
        positions: [],
        locations: [],
        companies: [],
      },
      maps: {
        categories: null,
        positions: null,
        locations: null,
        companies: null,
      },
    };
  }

  onJobDetailsChanged(state, data) {
    state.details = data.details;
  }

  onPavilionsChanged(state, data) {
    state.background = data.backgroundURL;
  }

  onActiveJobsChanged(state, data) {
    state.activeJobs = data.activeJobs;
  }

  onJobsChanged(state, data) {
    Object.assign(state, data);
    state.loading = false;

    var map = [];

    state.index = lunr(function() {
      this.use(lunr.multiLanguage("en", "ru"));

      this.field("title");
      this.field("location");
      this.field("stand");
      this.field("company");
      this.field("category");

      this.pipeline.remove(lunr.stemmer);
      // this.pipeline.remove(lunr.stopWordFilter);
      // this.searchPipeline.remove(lunr.stemmer);

      data.jobs.forEach((item) => {
        let locationsArray = [];
        if (item.location) {
          let locations = item.location.split(",");
          locations.forEach((location) => {
            locationsArray.push(location.trim());
          });
        }

        var job = {
          id: item.id,
          title: [item.title],
          //t: item.title,
          location: locationsArray,
          //l: item.location,
          stand: item.stand.title,
          company: [item.stand.companyName],
          //c: item.stand.companyName
        };

        if (item.offerCategory) {
          job.category = item.offerCategory.name;
        }

        this.add(job);

        map[item.id] = item;
      });
    });

    let mapCategories = [];
    state.indexes.categories = lunr(function() {
      this.use(lunr.multiLanguage("en", "ru"));
      this.field("category");
      this.pipeline.remove(lunr.stemmer);
      // this.searchPipeline.remove(lunr.stemmer);
      this.pipeline.remove(lunr.stopWordFilter);

      data.jobs.forEach((item) => {
        let job = {
          id: item.id,
          category: item.offerCategory ? [item.offerCategory.name] : null,
        };
        this.add(job);
      });
    });

    let mapPositions = [];
    state.indexes.positions = lunr(function() {
      this.use(lunr.multiLanguage("en", "ru"));
      this.field("title");
      this.pipeline.remove(lunr.stemmer);
      // this.searchPipeline.remove(lunr.stemmer);
      // this.pipeline.remove(lunr.stopWordFilter);

      data.jobs.forEach((item) => {
        let job = {
          id: item.id,
          title: [item.title],
        };
        this.add(job);
      });
    });

    let mapLocations = [];
    state.indexes.locations = lunr(function() {
      this.use(lunr.multiLanguage("en", "ru"));
      this.field("location");
      this.pipeline.remove(lunr.stemmer);
      // this.searchPipeline.remove(lunr.stemmer);
      // this.pipeline.remove(lunr.stopWordFilter);

      data.jobs.forEach((item) => {
        let locationsArray = [];
        if (item.location) {
          let locations = item.location.split(",");
          locations.forEach((location) => {
            locationsArray.push(location.trim());
          });
        }

        let job = {
          id: item.id,
          location: locationsArray,
        };
        this.add(job);
      });
    });

    let mapCompanies = [];
    state.indexes.companies = lunr(function() {
      this.use(lunr.multiLanguage("en", "ru"));
      this.field("company");
      this.pipeline.remove(lunr.stemmer);
      // this.searchPipeline.remove(lunr.stemmer);
      this.pipeline.remove(lunr.stopWordFilter);

      data.jobs.forEach((item) => {
        let job = {
          id: item.id,
          company: [item.stand.companyName],
        };
        this.add(job);
      });
    });

    /*
     * Fill filtersPrepare objects with all possible values
     */
    let filtersPrepare = Object.assign({}, this.getInitialState().filters);
    data.jobs.map((job) => {
      if (job.title) {
        filtersPrepare.positions.push(job.title);
      }

      if (job.location) {
        let locations = job.location.split(",");
        locations.forEach((location) => {
          filtersPrepare.locations.push(location.trim());
        });
      }

      if (job.stand.companyName) {
        filtersPrepare.companies.push(job.stand.companyName.trim());
      }

      if (job.offerCategory) {
        filtersPrepare.categories.push(job.offerCategory.name);
      }
    });

    let filterKeys = Object.keys(state.filters);
    filterKeys.forEach((filterKey) => {
      filtersPrepare[filterKey].sort((a, b) => {
        return a.toLowerCase().localeCompare(b.toLowerCase(), "hr");
      });
      let unique = filtersPrepare[filterKey].filter(
        (v, i, a) => a.indexOf(v) === i
      );
      state.filters[filterKey] = unique.map((name, i) => {
        const initial = state.initialFilters[filterKey];
        const selected = initial && initial.includes(name);
        return {
          index: filterKey + i,
          name: name,
          selected: selected,
          active: selected,
        };
      });
    });

    state.map = map;
    state.maps.categories = mapCategories;
    state.maps.positions = mapPositions;
    state.maps.locations = mapLocations;
    state.maps.companies = mapCompanies;
  }

  onJobsLoading(state, data) {
    state.loading = true;
    state.jobs = null;
    state.standId = data.standId;
  }

  onJobFastApplyClicked(state, data) {
    var prop = this.getActiveJobsName();
    var jobs = [...state[prop]];

    var index = jobs.findIndex((job) => {
      return job.id === data.id;
    });
    if (index !== -1) {
      if (!jobs[index].applied) {
        jobs[index].selected = !Boolean(jobs[index].selected);
      }
      state[prop] = jobs;
    }
  }

  onSearchQueryChanged(state, data) {
    state.query = data.query;
  }

  onJobFiltersSet(state, data) {
    state.initialFilters = {
      categories: data.categories ? data.categories : [],
      positions: data.positions ? data.positions : [],
      locations: data.locations ? data.locations : [],
      companies: data.companies ? data.companies : [],
    };
  }

  onJobsFiltersChanged(state, data) {
    state.filters[data.filterName] = data.filters;

    console.log("FCCCC", state.filters);
  }

  filter(query, filters) {
    var state = this.getState();
    var tokens = query.split(/\s+/);

    let categories = [];
    filters.categories.forEach((category) => {
      if (category.active) categories.push(category.name);
    });

    let positions = [];
    filters.positions.forEach((position) => {
      if (position.active) positions.push(position.name);
    });

    let locations = [];
    filters.locations.forEach((loc) => {
      if (loc.active) locations.push(loc.name);
    });

    let companies = [];
    filters.companies.forEach((company) => {
      if (company.active) companies.push(company.name);
    });

    state.activeFilters = {
      categories: categories,
      positions: positions,
      locations: locations,
      companies: companies,
    };

    /**
     * Edge cases
     * Trim characters [ .šđčćž] from start and end. Also trim '(' from start and ')' from end.
     * Strings ending in /ž) and ') and ’) are trimmed
     * @type {RegExp}
     */
    let cleaner = /^([ .šđčćž(])|([ .šđčćž)])$|(\/ž\)|'\)|’\))$/gi;

    /**
     * Edge cases
     * Terms ending on 'x' were not found.. i guess add * after ending with letter 'x'
     */
    let replacer = /([strel])$/gi;

    let srCategory = state.indexes.categories.query((q) => {
      categories.forEach((category) => {
        let term = category.replace(cleaner, "").toLowerCase();
        term = term.replace(replacer, "$1*").toLowerCase();
        q.term(term, {
          fields: ["category"],
        });
        // console.log('added category', term);
      });
    });

    let srPosition = state.indexes.positions.query((q) => {
      positions.forEach((position) => {
        let term = position.replace(cleaner, "").toLowerCase();
        term = term.replace(replacer, "$1*").toLowerCase();
        q.term(term, {
          fields: ["title"],
        });
        // console.log('added title', term);
      });
    });

    let srLocation = state.indexes.locations.query((q) => {
      locations.forEach((location) => {
        let term = location.replace(cleaner, "").toLowerCase();
        term = term.replace(replacer, "$1*").toLowerCase();
        q.term(term, {
          fields: ["location"],
        });
        // console.log('added location', term);
      });
    });

    /*
    let srCompany = state.index.query((q) => {
      companies.forEach((company) => {
        console.log("COMPANY", company);
        let term = company.replace(cleaner, "").toLowerCase();
        term = term.replace(replacer, "$1*").toLowerCase();
        console.log("COMPANYTERM", term);
        q.term(term, {
          fields: ["company"],
        });
        // console.log("added company", term);
      });
    });
    */

    let srCompany = [];
    state.jobs.forEach((job) => {
      if (companies.length) {
        companies.forEach((company) => {
          if (
            job.stand.companyName &&
            company === job.stand.companyName.trim()
          ) {
            srCompany.push({
              ref: job.id.toString(),
            });
          }
        });
      } else {
        srCompany.push({
          ref: job.id.toString(),
        });
      }
    });

    let matchedByCategory = srCategory.map((i) => i.ref);
    let matchedByPosition = srPosition.map((i) => i.ref);
    let matchedByLocation = srLocation.map((i) => i.ref);
    let matchedByCompany = srCompany.map((i) => i.ref);

    let intersected = [
      matchedByCategory,
      matchedByPosition,
      matchedByLocation,
      matchedByCompany,
    ].reduce((a, b) => a.filter((c) => b.includes(c)));

    return intersected.map((item) => {
      return state.map[item];
    });
  }

  isLoading() {
    return this.getState().loading == true;
  }

  getJobs() {
    return this.getState().jobs;
  }

  isFiltered() {
    var state = this.getState();

    if (state.query !== "") {
      return true;
    }

    const filters = state.filters;

    // This block will return bool 'true' if there is an active filter
    let hasActiveIndex = false;
    let filterKeys = Object.keys(filters);
    filterKeys.forEach((filterKey) => {
      let activeIndex = filters[filterKey].findIndex((item, i) => {
        return item.active;
      });
      if (activeIndex !== -1) {
        hasActiveIndex = true;
        return true;
      }
    });
    return hasActiveIndex;
  }

  getActiveJobs() {
    var state = this.getState();

    if (!this.isFiltered()) {
      return this.getState().jobs;
    } else {
      return this.getState().activeJobs;
    }
  }

  getActiveJobsName() {
    var state = this.getState();

    if (!this.isFiltered()) {
      return "jobs";
    } else {
      return "activeJobs";
    }
  }

  getBackground() {
    return this.getState().background;
  }

  getQuery() {
    return this.getState().query;
  }

  getActiveStandId() {
    return this.getState().standId;
  }

  getDetails() {
    return this.getState().details;
  }

  getFilters() {
    return this.getState().filters;
  }

  getActiveFilters() {
    return this.getState().activeFilters;
  }

  getSelectedJobs() {
    var selectedJobs = this.getState().jobs.filter(function(job) {
      return job.id && job.selected;
    });
    return selectedJobs.map((job) => {
      return job.id;
    });
  }

  onFastAppliedSuccess(state, data) {
    if (!data.success.length) {
      // return;
    }

    let prop = this.getActiveJobsName();
    let jobs = [...state[prop]];

    state[prop] = jobs.map((job) => {
      if (data.success.includes(job.remoteId)) {
        job.applied = true;
        job.selected = false;
      }
      //refs #150738
      if (data.fail.includes(job.remoteId)) {
        job.applied = true;
        job.selected = false;
      }
      return job;
    });
  }
}

const store = new JobStore();
export default store;



// WEBPACK FOOTER //
// ./src/modules/model/jobstore.js